import { notification } from "antd";

/**
 * Displays a notification with the specified type, message, and description.
 *
 * @param {string} type - The type of the notification (e.g., 'success', 'info', 'warning', 'error').
 * @param {string} message - The message to be displayed in the notification.
 * @param {string} description - The description to be displayed in the notification.
 */
export const showNotification = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
        duration: 3,
    });
}

/**
 * Handles the notification based on the provided parameters.
 *
 * @param {boolean} isFetching - Indicates if the operation is currently fetching data.
 * @param {boolean} isSuccess - Indicates if the operation was successful.
 * @param {boolean} isError - Indicates if the operation encountered an error.
 * @param {object} error - The error object, if any.
 * @param {string} successMessage - The success message to display.
 * @param {string} errorMessage - The error message to display.
 * @param {function} t - The translation function.
 */
export const handleNotification = (isFetching, isSuccess, isError, error, successMessage, errorMessage, t) => {

    if (isFetching) return;

    if (isSuccess) {

        showNotification('success', t('Success'), t(successMessage));

    } else if (isError) {

        const detailedErrorMessage = error?.response?.data?.detailedMessage || t(errorMessage);
        showNotification('error', t('Error'), t(detailedErrorMessage));

    }
}


/**
 * Handles notification with action based on the provided parameters.
 *
 * @param {boolean} isFetching - Indicates if the action is currently fetching data.
 * @param {boolean} isSuccessful - Indicates if the action was successful.
 * @param {boolean} isError - Indicates if an error occurred during the action.
 * @param {Error|null} error - The error object, if any.
 * @param {string} successMessage - The success message to display.
 * @param {string} errorMessage - The error message to display.
 * @param {function} t - The translation function.
 * @param {function} onSuccess - The callback function to execute on success.
 * @param {function} onSuccessOrError - The callback function to execute on success or error.
 */
export const handleNotificationWithAction = (isFetching, isSuccessful, isError, error, successMessage, errorMessage, t, onSuccess, onSuccessOrError) => {
    handleNotification(isFetching, isSuccessful, isError, error, successMessage, errorMessage, t);

    if (isSuccessful) {
        onSuccess();
    }

    if (isSuccessful || isError) {
        onSuccessOrError();
    }
}